module.exports = __webpack_public_path__ + "static/img-video_thumb-linda-3914a8ad106fd0a107c215b42910d086.png";